import { useState } from "react";
import { apiFetch } from "../services/api.js";

export default function FormCriarAnual({ campanhas = [], onSuccess }) {
  const [nome, setNome] = useState("");
  const [quantidadePremios, setQuantidadePremios] = useState(1);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [criando, setCriando] = useState(false);

  // Filtrar apenas campanhas ativas e não arquivadas
  const campanhasDisponiveis = campanhas.filter(
    (c) => c.ativo !== false && c.arquivado !== true,
  );

  async function handleSubmit(e) {
    e.preventDefault();
    setErro("");
    setSucesso("");
    setCriando(true);

    try {
      if (!nome.trim()) throw new Error("Nome obrigatorio");
      if (quantidadePremios < 1)
        throw new Error("Quantidade de premios invalida");

      const res = await apiFetch("anuais", {
        method: "POST",
        body: JSON.stringify({
          nome,
          quantidade_premios: quantidadePremios,
        }),
      });

      setSucesso(`Sorteio anual "${nome}" criado com sucesso!`);
      setNome("");
      setQuantidadePremios(1);
      onSuccess && onSuccess();

      setTimeout(() => setSucesso(""), 4000);
    } catch (err) {
      setErro(err.message || "Erro ao criar anual");
      console.error("[ERRO ANUAL]", err);
    } finally {
      setCriando(false);
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        padding: "1.5rem",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
      }}
    >
      <h3>Criar Sorteio Anual</h3>

      <div>
        <label>Nome do Sorteio Anual:</label>
        <input
          value={nome}
          placeholder="Ex: Sorteio Fim de Ano, Sorteio Primavera"
          onChange={(e) => setNome(e.target.value)}
          disabled={criando}
          required
        />
      </div>

      <div>
        <label>Quantidade de premios:</label>
        <input
          type="number"
          min="1"
          max="1000"
          value={quantidadePremios}
          onChange={(e) => setQuantidadePremios(parseInt(e.target.value) || 1)}
          disabled={criando}
        />
      </div>

      {campanhasDisponiveis.length === 0 && (
        <p style={{ color: "#d9534f", fontSize: "0.9rem" }}>
          Crie campanhas ativas primeiro para criar um anual.
        </p>
      )}

      <button
        type="submit"
        disabled={criando || campanhasDisponiveis.length === 0}
      >
        {criando ? "Criando..." : "Criar Sorteio Anual"}
      </button>

      {erro && <p className="error-message">{erro}</p>}
      {sucesso && (
        <p style={{ color: "#27ae60", fontWeight: "600", marginTop: "0.5rem" }}>
          {sucesso}
        </p>
      )}
    </form>
  );
}
